import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { LABEL_FORMATS } from "@/lib/labelFormat";

export const LabelFormatSelect = ({ value, onChange, testId = "label-format-select", label = "Labelformat", disabled = false }) => (
  <div>
    <Label>{label}</Label>
    <Select value={value || ""} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger data-testid={testId} aria-label={label}><SelectValue placeholder="Format wählen" /></SelectTrigger>
      <SelectContent>
        {LABEL_FORMATS.map((f) => <SelectItem key={f.value} value={f.value} data-testid={`${testId}-${f.value}`}>{f.label}</SelectItem>)}
      </SelectContent>
    </Select>
  </div>
);
